<div class="orderWrapper">
  <div class="order">
    <div class="orderHeader">
      <div class="headerText">
        <div class="backButton" (click)="builderService.navigateBack()">
          <img src="/assets/icons/arrow-left.svg" alt="Go back" />
        </div>
        <p class="orders_title">{{'Orders' | translate}}</p>
        <p class="orders_sub">{{'Manage product orders and track your limits.' | translate}}</p>
      </div>
      <div class="headerBtns">
        <button *ngIf="orderData?.order?.fincartOrderId?.fincartId" class="printLabelBtn" (click)="printFincartLabel()">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="11" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="6 9 6 2 18 2 18 9"></polyline>
            <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
            <rect x="6" y="14" width="12" height="8"></rect>
          </svg>
          {{'Print Label' | translate}}
        </button>
        <button class="btn-save" (click)="saveUpdateStatus()" [disabled]="!allowUpdateStatus">
          {{ 'Save' | translate }}
        </button>
        <button *ngIf="fincartActivated" (click)="shipWithFincart()">
          <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M13.7141 4.61758C13.7141 4.61529 13.714 4.61301 13.7139 4.60958C13.7102 4.43771 13.5721 4.30078 13.3982 4.30078H13.3153L12.035 1.82557C11.981 1.72099 11.8733 1.65597 11.7544 1.65593L9.56862 1.65547L9.65201 0.994491C9.6758 0.730343 9.59414 0.480937 9.42201 0.29216C9.25021 0.103771 9.01034 0 8.74655 0H1.96274C1.79217 0 1.64728 0.131977 1.63102 0.302126L1.56302 0.846709H5.4281C5.67907 0.846709 5.87719 1.05016 5.87064 1.30113C5.86404 1.5521 5.65528 1.75554 5.40431 1.75554H4.11509C4.11532 1.75619 4.11555 1.75669 4.11577 1.75783H0.32989C0.152407 1.75783 0.00475355 1.90168 0.000112068 2.07917C-0.00452907 2.25665 0.135561 2.4005 0.313044 2.4005H5.32514C5.5578 2.43639 5.73162 2.63754 5.72522 2.88114C5.71822 3.14867 5.49675 3.36559 5.22968 3.36783H1.77422C1.59496 3.36783 1.44584 3.51314 1.44114 3.69241C1.43643 3.87168 1.57795 4.01699 1.75722 4.01699H5.17197C5.40804 4.04991 5.58533 4.25271 5.5789 4.49869C5.57186 4.76757 5.34815 4.98555 5.07927 4.98555H1.16177L0.832605 4.98591C0.653337 4.98591 0.504224 5.13123 0.499517 5.3105C0.494808 5.48976 0.636297 5.63509 0.815597 5.63509H1.09967L0.988568 6.79768C0.964744 7.06179 1.04641 7.3112 1.21857 7.49998C1.39034 7.6884 1.63024 7.79214 1.89403 7.79214H2.13909C2.25587 8.45993 2.83363 8.9645 3.54035 8.9645C4.24707 8.9645 4.85125 8.45993 5.00293 7.79217H8.06112C8.30839 7.79217 8.54248 7.69766 8.72607 7.54282C8.89394 7.70394 9.11648 7.79217 9.35946 7.79217H9.40977C9.52652 8.45993 10.1043 8.9645 10.811 8.9645C11.5177 8.9645 12.1219 8.45993 12.2736 7.79217H12.4755C13.0013 7.79217 13.4677 7.36466 13.5151 6.83919L13.7129 4.64806C13.7131 4.64463 13.713 4.64234 13.7132 4.63891C13.7135 4.63434 13.7141 4.62977 13.7143 4.62543C13.7143 4.62314 13.7141 4.61986 13.7141 4.61758ZM3.55736 8.31527C3.10992 8.31527 2.75541 7.95128 2.76713 7.50384C2.77885 7.05637 3.15241 6.69234 3.59985 6.69234C4.04729 6.69234 4.40177 7.05637 4.39005 7.50384C4.37833 7.95128 4.0048 8.31527 3.55736 8.31527ZM10.828 8.31527C10.3806 8.31527 10.0261 7.95128 10.0378 7.50384C10.0495 7.05637 10.4231 6.69234 10.8705 6.69234C11.318 6.69234 11.6725 7.05637 11.6607 7.50384C11.649 7.95128 11.2755 8.31527 10.828 8.31527ZM12.8684 6.79761C12.8515 6.9848 12.6794 7.14294 12.4925 7.14294H12.2742C12.1296 6.51152 11.5684 6.04318 10.8875 6.04318C10.2066 6.04318 9.62092 6.51152 9.4433 7.14294H9.37647C9.29396 7.14294 9.22035 7.11197 9.1691 7.05574C9.11752 6.99917 9.09324 6.92224 9.10074 6.83904L9.51001 2.3049L10.45 2.3051L10.301 3.95567C10.2771 4.21978 10.3588 4.46919 10.5309 4.65797C10.7027 4.84642 10.9426 4.95023 11.2064 4.95023H13.0351L12.8684 6.79761Z"
              fill="white" />
          </svg>
          {{ 'Ship Now' | translate }}
        </button>
        <button *ngIf="shipmentLabelUrl" class="printLabelBtn" (click)="openShipmentLabel()">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="11" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="6 9 6 2 18 2 18 9"></polyline>
            <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
            <rect x="6" y="14" width="12" height="8"></rect>
          </svg>
          {{ 'Print Label' | translate }}
        </button>
        <button *ngIf="shippingProviderEnabled" [disabled]="shipmentLoading" (click)="shipNow()">
          <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M13.7141 4.61758C13.7141 4.61529 13.714 4.61301 13.7139 4.60958C13.7102 4.43771 13.5721 4.30078 13.3982 4.30078H13.3153L12.035 1.82557C11.981 1.72099 11.8733 1.65597 11.7544 1.65593L9.56862 1.65547L9.65201 0.994491C9.6758 0.730343 9.59414 0.480937 9.42201 0.29216C9.25021 0.103771 9.01034 0 8.74655 0H1.96274C1.79217 0 1.64728 0.131977 1.63102 0.302126L1.56302 0.846709H5.4281C5.67907 0.846709 5.87719 1.05016 5.87064 1.30113C5.86404 1.5521 5.65528 1.75554 5.40431 1.75554H4.11509C4.11532 1.75619 4.11555 1.75669 4.11577 1.75783H0.32989C0.152407 1.75783 0.00475355 1.90168 0.000112068 2.07917C-0.00452907 2.25665 0.135561 2.4005 0.313044 2.4005H5.32514C5.5578 2.43639 5.73162 2.63754 5.72522 2.88114C5.71822 3.14867 5.49675 3.36559 5.22968 3.36783H1.77422C1.59496 3.36783 1.44584 3.51314 1.44114 3.69241C1.43643 3.87168 1.57795 4.01699 1.75722 4.01699H5.17197C5.40804 4.04991 5.58533 4.25271 5.5789 4.49869C5.57186 4.76757 5.34815 4.98555 5.07927 4.98555H1.16177L0.832605 4.98591C0.653337 4.98591 0.504224 5.13123 0.499517 5.3105C0.494808 5.48976 0.636297 5.63509 0.815597 5.63509H1.09967L0.988568 6.79768C0.964744 7.06179 1.04641 7.3112 1.21857 7.49998C1.39034 7.6884 1.63024 7.79214 1.89403 7.79214H2.13909C2.25587 8.45993 2.83363 8.9645 3.54035 8.9645C4.24707 8.9645 4.85125 8.45993 5.00293 7.79217H8.06112C8.30839 7.79217 8.54248 7.69766 8.72607 7.54282C8.89394 7.70394 9.11648 7.79217 9.35946 7.79217H9.40977C9.52652 8.45993 10.1043 8.9645 10.811 8.9645C11.5177 8.9645 12.1219 8.45993 12.2736 7.79217H12.4755C13.0013 7.79217 13.4677 7.36466 13.5151 6.83919L13.7129 4.64806C13.7131 4.64463 13.713 4.64234 13.7132 4.63891C13.7135 4.63434 13.7141 4.62977 13.7143 4.62543C13.7143 4.62314 13.7141 4.61986 13.7141 4.61758ZM3.55736 8.31527C3.10992 8.31527 2.75541 7.95128 2.76713 7.50384C2.77885 7.05637 3.15241 6.69234 3.59985 6.69234C4.04729 6.69234 4.40177 7.05637 4.39005 7.50384C4.37833 7.95128 4.0048 8.31527 3.55736 8.31527ZM10.828 8.31527C10.3806 8.31527 10.0261 7.95128 10.0378 7.50384C10.0495 7.05637 10.4231 6.69234 10.8705 6.69234C11.318 6.69234 11.6725 7.05637 11.6607 7.50384C11.649 7.95128 11.2755 8.31527 10.828 8.31527ZM12.8684 6.79761C12.8515 6.9848 12.6794 7.14294 12.4925 7.14294H12.2742C12.1296 6.51152 11.5684 6.04318 10.8875 6.04318C10.2066 6.04318 9.62092 6.51152 9.4433 7.14294H9.37647C9.29396 7.14294 9.22035 7.11197 9.1691 7.05574C9.11752 6.99917 9.09324 6.92224 9.10074 6.83904L9.51001 2.3049L10.45 2.3051L10.301 3.95567C10.2771 4.21978 10.3588 4.46919 10.5309 4.65797C10.7027 4.84642 10.9426 4.95023 11.2064 4.95023H13.0351L12.8684 6.79761Z"
              fill="white" />
          </svg>
          {{ (shipmentLoading ? 'Shipping...' : 'Ship Now') | translate }}
        </button>
      </div>
    </div>
    <div class="orderDataWrapper">
      <!-- Order Details -->
      <div class="orderDetails">
        <h3>{{ 'Order Details' | translate }}</h3>
        <!-- orders tabel-->
        <div class="order-items">
          <div class="tableWrapper">
            <ng-container *ngIf="orderData?.order?.products?.length > 0">
              <table class="order-items-table">
                <thead>
                  <tr>
                    <th>{{ 'Product' | translate }}</th>
                    <th>{{ 'Type' | translate }}</th>
                    <th>{{ 'Price' | translate }}</th>
                    <th>{{ 'Quantity' | translate }}</th>
                    <th>{{ 'Total' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let product of orderData?.order?.products">
                    <td class="product-cell">
                      <div class="product-info">
                        <img *ngIf="product?.imageUrl" [src]="product?.imageUrl" class="product-img" alt="product" />
                        <img *ngIf="!product?.imageUrl" src="assets/images/empty-image.png" class="product-img"
                          alt="product" />
                        <div class="product-details">
                          <span class="product-name">{{ product?.productName }}</span>
                          <span *ngIf="
                        (product?.productType === 'variable' || product?.selectedVariation) &&
                        product?.selectedVariation?.values
                      " class="variation-info"> {{ getSelectedVariationLabel(product) }}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td class="type-cell">
                      <span class="type-badge" [ngClass]="product?.productType === 'variable' ? 'variable' : 'simple'">
                        {{ (product?.productType
                        ? product.productType
                        : product?.selectedVariation
                        ? 'variable'
                        : 'simple'
                        ) | translate }} </span>
                    </td>
                    <td class="price-cell">
                      <span class="sale-price"><span class="currency-symbol">{{ settingsService.currency }}</span> {{ product?.salePrice || product?.regularPrice }}</span>
                      <span *ngIf="product?.salePrice && product?.regularPrice" class="original-price"><span class="currency-symbol">{{ settingsService.currency }}</span> {{
                        product?.regularPrice }}</span>
                    </td>
                    <td class="quantity-cell">x{{ product?.quantity }}</td>
                    <td class="total-cell"><span class="currency-symbol">{{ settingsService.currency }}</span> {{ (product?.salePrice || product?.regularPrice) *
                      product?.quantity }}</td>
                  </tr>
                </tbody>
              </table>
            </ng-container>
          </div>
          <!-- Refunded Items Section -->
          <ng-container *ngIf="orderData?.order?.refunded_items?.length > 0 && orderData?.order?.status !== 'Refunded'">
            <div class="tableWrapper">
              <div class="tableHeader">
                <h3>{{ 'Refunded Items' | translate }}</h3>
              </div>
              <table mat-table [dataSource]="orderData?.order?.refunded_items" class="mat-elevation-z8">
                <ng-container matColumnDef="product_name">
                  <th mat-header-cell *matHeaderCellDef class="firstTitle">{{ 'Product Name' | translate }}</th>
                  <td mat-cell *matCellDef="let item">{{ item?.name }}</td>
                </ng-container>

                <ng-container matColumnDef="quantity">
                  <th mat-header-cell *matHeaderCellDef class="firstTitle">{{ 'Quantity' | translate }}</th>
                  <td mat-cell *matCellDef="let item">x{{ item?.quantity }}</td>
                </ng-container>

                <ng-container matColumnDef="refund_amount">
                  <th mat-header-cell *matHeaderCellDef class="firstTitle">{{ 'Refunded Amount' | translate }}</th>
                  <td mat-cell *matCellDef="let item" style="color: #d32f2f; font-weight: 600">-<span
                      class="currency-symbol">{{ settingsService.currency }}</span> {{ item?.total }}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="['product_name', 'quantity', 'refund_amount']"></tr>
                <tr mat-row *matRowDef="let row; columns: ['product_name', 'quantity', 'refund_amount']"></tr>
              </table>
            </div>
          </ng-container>
        </div>
        <div class="orderSummary">
          <form id="orderStatusForm" (ngSubmit)="saveUpdateStatus()">
          <div class="orderStat">
            <p>
              {{ 'Order Status' | translate }}
            </p>
            <div class="filter-dropdown">
              <button type="button" class="filter-btn" [class.placeholder]="!selectedStatus" (click)="toggleStatusDropdown($event)">
                <span>{{ (selectedStatus || 'Select status') | translate }}</span>
                <svg class="arrow" [class.open]="showStatusDropdown" width="12" height="12" viewBox="0 0 12 12"
                  fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.95906 4.47461L6.69906 7.73461C6.31406 8.11961 5.68406 8.11961 5.29906 7.73461L2.03906 4.47461"
                    stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </button>
              <div class="dropdown-panel" *ngIf="showStatusDropdown">
                <div class="dropdown-search">
                  <input type="text" [placeholder]="'Search status...' | translate" [(ngModel)]="statusSearch"
                    [ngModelOptions]="{standalone: true}"
                    (input)="filterStatuses()" (click)="$event.stopPropagation()" />
                </div>
                <div class="dropdown-options">
                  <div *ngFor="let status of filteredStatuses" class="dropdown-option"
                    [class.selected]="selectedStatus === status" (click)="selectStatus(status)">
                    {{ status | translate }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          </form>

          <!-- Meta Ads campaign attribution — for chat-closed (e.g. Instagram DM) orders the
               Meta Pixel/Insights API never sees, so campaign analysis would otherwise miss them. -->
          <div class="orderStat">
            <p>{{ 'Meta Ads Campaign' | translate }}</p>
            <div class="filter-dropdown">
              <button type="button" class="filter-btn" [class.placeholder]="!selectedMetaCampaignName" (click)="toggleMetaCampaignDropdown($event)">
                <span>{{ selectedMetaCampaignName ? (selectedMetaCampaignName + ' (' + selectedMetaCampaignStatus + ')') : ('Select campaign...' | translate) }}</span>
                <svg class="arrow" [class.open]="showMetaCampaignDropdown" width="12" height="12" viewBox="0 0 12 12"
                  fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.95906 4.47461L6.69906 7.73461C6.31406 8.11961 5.68406 8.11961 5.29906 7.73461L2.03906 4.47461"
                    stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </button>
              <div class="dropdown-panel" *ngIf="showMetaCampaignDropdown">
                <div class="dropdown-search">
                  <input type="text" [placeholder]="'Search campaign...' | translate" [(ngModel)]="metaCampaignSearch"
                    [ngModelOptions]="{standalone: true}"
                    (input)="filterMetaCampaigns()" (click)="$event.stopPropagation()" />
                </div>
                <div class="dropdown-options">
                  <div *ngFor="let campaign of filteredMetaCampaigns" class="dropdown-option"
                    [class.selected]="selectedMetaCampaignId === campaign.id" (click)="selectMetaCampaign(campaign)">
                    {{ campaign.name }} <span class="meta-status meta-status--{{ campaign.status }}">{{ campaign.status }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="orderStat" *ngIf="selectedMetaCampaignId">
            <p>{{ 'Meta Ads Ad Set' | translate }}</p>
            <div class="filter-dropdown">
              <button type="button" class="filter-btn" [class.placeholder]="!selectedMetaAdSetName" (click)="toggleMetaAdSetDropdown($event)">
                <span>{{ selectedMetaAdSetName ? (selectedMetaAdSetName + ' (' + selectedMetaAdSetStatus + ')') : ('Select ad set...' | translate) }}</span>
                <svg class="arrow" [class.open]="showMetaAdSetDropdown" width="12" height="12" viewBox="0 0 12 12"
                  fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.95906 4.47461L6.69906 7.73461C6.31406 8.11961 5.68406 8.11961 5.29906 7.73461L2.03906 4.47461"
                    stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </button>
              <div class="dropdown-panel" *ngIf="showMetaAdSetDropdown">
                <div class="dropdown-search">
                  <input type="text" [placeholder]="'Search ad set...' | translate" [(ngModel)]="metaAdSetSearch"
                    [ngModelOptions]="{standalone: true}"
                    (input)="filterMetaAdSets()" (click)="$event.stopPropagation()" />
                </div>
                <div class="dropdown-options">
                  <div *ngFor="let adSet of filteredMetaAdSets" class="dropdown-option"
                    [class.selected]="selectedMetaAdSetId === adSet.id" (click)="selectMetaAdSet(adSet)">
                    {{ adSet.name }} <span class="meta-status meta-status--{{ adSet.status }}">{{ adSet.status }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="orderStat" *ngIf="selectedMetaCampaignId && selectedMetaAdSetId">
            <button type="button" class="btn-save" [disabled]="savingMetaAttribution" (click)="saveMetaAttribution()">
              {{ savingMetaAttribution ? ('Saving...' | translate) : ('Save Attribution' | translate) }}
            </button>
          </div>

          <div class="orderBrief">
            <div>
              <p>{{'Order ID' | translate }}</p>
              <p class="data">#{{ orderData?.order?.humId || orderData?.order?.id }}</p>
            </div>
            <div *ngIf="orderData?.order?.fincartOrderId">
              <p>{{'Fincart Order Id' | translate}}</p>
              <p class="data"><button (click)="openFincartOrder(fincartOrderId)">{{fincartOrderCode}}</button></p>
            </div>
            <div *ngIf="orderData?.order?.fincartOrderId">
              <p>{{'Fincart Tracking URL' | translate}}</p>
              <p class="data"><button (click)="openFincartTracking(trackingUrl)">{{'Track Order' | translate}}</button>
              </p>
            </div>
            <div *ngIf="shipmentTrackingNumber">
              <p>{{'Tracking Number' | translate}}</p>
              <p class="data">{{shipmentTrackingNumber}}</p>
            </div>
            <div *ngIf="shipmentLabelUrl">
              <p>{{'Shipping Label' | translate}}</p>
              <p class="data"><button (click)="openShipmentLabel()">{{'Print Label' | translate}}</button></p>
            </div>
            <div>
              <p>{{'Date' | translate }}</p>
              <p class="data">{{orderData?.order?.date | date:'yyyy/MM/dd HH:mm:ss'}}</p>
            </div>
            <div>
              <p>{{'Payment' | translate }}</p>
              <p class="data">{{orderData?.order?.payment_method || '-'}}</p>
            </div>
            <div *ngIf="orderData?.order?.subtotal || orderData?.order?.subTotal">
              <p>{{'Items Subtotal' | translate }}</p>
              <p class="data"><span class="currency-symbol">{{ settingsService.currency }}</span> {{orderData?.order?.subtotal || orderData?.order?.subTotal}}</p>
            </div>
            <div *ngIf="orderData?.order?.couponCode || orderData?.order?.couponName || orderData?.order?.couponsDiscount">
              <p>{{'Coupon' | translate }}
                <span *ngIf="orderData?.order?.couponCode || orderData?.order?.couponName" class="bold">
                  ({{orderData?.order?.couponCode || orderData?.order?.couponName}})
                </span>
              </p>
              <p class="data"><span class="currency-symbol">{{ settingsService.currency }}</span> {{orderData?.order?.discount || orderData?.order?.couponsDiscount}}</p>
            </div>
            <div *ngIf="orderData?.order?.pointsDiscount">
              <p>{{'Points Redeemed' | translate }} </p>
              <p class="data"><span class="currency-symbol">{{ settingsService.currency }}</span> {{orderData?.order?.pointsDiscount }}</p>
            </div>

            <div *ngIf="pointsEarned > 0">
              <p>{{'Points Earned' | translate }}</p>
              <p class="data">{{pointsEarned}} {{'pts' | translate}}</p>
            </div>
            <div *ngIf="pointsRedeemed > 0">
              <p>{{'Points Redeemed (pts)' | translate }}</p>
              <p class="data">{{pointsRedeemed}} {{'pts' | translate}}</p>
            </div>
            <div *ngIf="userPointsBalance > 0">
              <p>{{'Customer Points Balance' | translate }}</p>
              <p class="data">{{userPointsBalance}} {{'pts' | translate}}</p>
            </div>

            <div *ngIf="orderData?.order?.discount || orderData?.order?.couponsDiscount || orderData?.order?.pointsDiscount">
              <p>{{'Subtotal After Discounts ' | translate }}</p>
              <p class="data"><span class="currency-symbol">{{ settingsService.currency }}</span> {{ orderData?.order?.subtotalAfterDiscounts | number:'1.2-2' }}</p>
            </div>
            <div *ngIf="orderData?.order?.shippingPrice">
              <p>{{'shipping ' | translate }}</p>
              <p class="data"><span class="currency-symbol">{{ settingsService.currency }}</span> {{orderData?.order?.shippingPrice}}</p>
            </div>
          </div>
          <div class="orderTotal">
            <p>{{'Total' | translate}}</p>
            <p class="data"><span class="currency-symbol">{{ settingsService.currency }}</span> {{orderData?.order?.total}}</p>
          </div>
        </div>


      </div>
      <!-- Order Tracking -->
      <div class="orderTrackingWrapper" *ngIf="orderService.orderStatuses.length > 0">
        <h3>{{ 'Order Tracking' | translate }}</h3>
        <div class="timeline">
          <div *ngFor="let entry of orderService.orderStatuses.slice().reverse(); let i = index; let last = last"
            class="timeline-item" [class.timeline-item--latest]="i === 0">
            <div class="timeline-marker">
              <div class="dot"></div>
              <div class="connector" *ngIf="!last"></div>
            </div>
            <div class="timeline-content">
              <span class="status-label">{{ entry.orderStatus | translate }}</span>
              <span class="status-time">{{ entry.stateChangeTime | date:'yyyy/MM/dd HH:mm:ss' }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- Order Tracking -->
      <!-- <div class="orderTrackingWrapper" *ngIf="this.orderService.orderStatuses.length !== 0">
      <h3>{{ 'Order Tracking' | translate }}</h3>
      <div class="statusData" [ngClass]="{ expanded: isExpanded }">
        <div *ngFor="let order of this.orderService.orderStatuses.slice().reverse(); let i = index">
          <div [class.firstLine]="i === 0" class="trackingLine">
            <div [class.first]="i === 0" [class.firstSecondCol]="(i === 5 && !isExpanded) || (i === 10 && isExpanded)"
              class="line"></div>
            <img [class.firstImg]="i === 0" src="assets/images/Ellipse 2059.svg" alt="" />
          </div>
          <p [class.firstP]="i === 0" class="status">{{ order.orderStatus }} :</p>
          <p [class.firstP]="i === 0" class="time">{{ order.stateChangeTime }}</p>
        </div>
      </div>
      <button class="showMore" [ngClass]="{ expanded: isExpanded }" *ngIf="this.orderService.orderStatuses.length > 10"
        (click)="toggleExpand()">
        <span class="material-symbols-outlined">keyboard_arrow_down</span>
        {{ isExpanded ? 'View Less' : 'View More' }}
      </button>
    </div> -->


    </div>

    <div class="orderDataWrapper">
      <!--user & address data-->
      <div class="userDetails">
        <div class="customerInfo" *ngIf="orderData?.user_data?.uid != 1">
          <h3>{{ 'User Info' | translate }}</h3>
          <div class="customerWrapper">
            <section *ngIf="orderData">
              <div>
                <div class="customerDetails">
                  <div class="item-container" *ngIf="orderData?.user_data?.given_name || orderData?.order?.guestName">
                    <p>{{ 'First Name' | translate }}</p>
                    <p class="data">
                      {{ orderData?.user_data?.given_name || orderData?.order?.guestName?.split(' ')[0] }}
                    </p>
                  </div>
                  <div class="item-container" *ngIf="orderData?.user_data?.family_name?.trim() || orderData?.order?.guestName?.split(' ').slice(1).join(' ')?.trim()">
                    <p>{{ 'Last Name' | translate }}</p>
                    <p class="data">
                      {{ orderData?.user_data?.family_name || orderData?.order?.guestName?.split(' ').slice(1).join(' ') }}
                      <!--{{ selectedAddress?.last_name || orderData?.user_data?.family_name || orderData?.order?.guestName?.split(' ').slice(1).join(' ') }}-->
                    </p>
                  </div>
                  <div class="item-container">
                    <p>{{ 'Email' | translate }}</p>
                    <p class="data">{{ orderData?.user_data?.email || orderData?.order?.guestEmail }}</p>
                  </div>
                  <div class="item-container" *ngIf="isPhoneNumber(orderData?.user_data?.name) || (orderData?.order?.guestPhone && !orderData?.user_data?.name )">
                    <p>{{ 'Phone Number' | translate }}</p>
                    <p class="data">
                      {{ orderData?.user_data?.name || orderData?.order?.guestPhone }}</p>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>

        <div
          *ngIf="selectedAddress?.billing_address_1 || selectedAddress?.billing_country || orderData?.order?.deliveryAddress || orderData?.order?.deliveryCountry">
          <div class="customerInfo">
            <h3>{{ 'Billing Address' | translate }}</h3>
            <div class="customerWrapper">
              <section *ngIf="orderData">
                <div>
                  <div class="customerDetails billing-details-grid">
                    <!--USER ADDRESS DATA-->
                    <div class="item-container" *ngIf="selectedAddress?.first_name">
                      <p>{{ 'First Name' | translate }}</p>
                      <p class="data">{{ selectedAddress?.first_name || '-' }}</p>
                    </div>
                    <div class="item-container" *ngIf="selectedAddress?.last_name">
                      <p>{{ 'Last Name' | translate }}</p>
                      <p class="data">{{ selectedAddress?.last_name || '-' }}</p>
                    </div>
                    <div class="item-container" *ngIf="selectedAddress?.phone_number || orderData?.order?.guestPhone">
                      <p>{{ 'Phone Number' | translate }}</p>
                      <p class="data">{{ (selectedAddress.country_code ? selectedAddress.country_code +
                        selectedAddress.phone_number : selectedAddress.phone_number) ||
                        orderData?.order?.guestPhone}}</p>
                    </div>
                    <div class="item-container"
                      *ngIf="selectedAddress?.billing_address_1 && !selectedAddress?.billing_street_No && !selectedAddress?.billing_street_Name">
                      <p>{{ 'Address' | translate }}</p>
                      <p class="data">{{ selectedAddress?.billing_address_1 || '-' }}</p>
                    </div>
                    <!-- STATUS and AREA -->
                    <div class="item-container"
                      *ngIf="selectedAddress?.billing_country || orderData?.order?.deliveryCountry">
                      <p>{{ 'Country' | translate }}</p>
                      <p class="data">{{ selectedAddress?.billing_country || orderData?.order?.deliveryCountry }}</p>
                    </div>
                    <div class="item-container"
                      *ngIf="selectedAddress?.billing_state || orderData?.order?.deliveryState">
                      <p>{{ 'State' | translate }}</p>
                      <p class="data">{{ selectedAddress?.billing_state || orderData?.order?.deliveryState }}</p>
                    </div>

                    <div class="item-container" *ngIf="selectedAddress?.billing_area || orderData?.order?.deliveryArea">
                      <p>{{ 'Area' | translate }}</p>
                      <p class="data">{{ selectedAddress?.billing_area || orderData?.order?.deliveryArea }}</p>
                    </div>
                    <div class="item-container" *ngIf="selectedAddress?.billing_city || orderData?.order?.deliveryCity">
                      <p>{{ 'City' | translate }}</p>
                      <p class="data">{{ selectedAddress?.billing_city || orderData?.order?.deliveryCity}}</p>
                    </div>
                    <div class="item-container" *ngIf="selectedAddress?.area">
                      <p>{{ 'Area' | translate }}</p>
                      <p class="data">{{ selectedAddress?.area || '-' }}</p>
                    </div>

                    <div class="item-container" *ngIf="selectedAddress?.billing_street_No">
                      <p>{{ 'Street Number' | translate }}</p>
                      <p class="data">{{ selectedAddress?.billing_street_No || '-' }}</p>
                    </div>

                    <div class="item-container" *ngIf="selectedAddress?.billing_street_Name">
                      <p>{{ 'Street Name' | translate }}</p>
                      <p class="data">{{ selectedAddress?.billing_street_Name || '-' }}</p>
                    </div>

                    <div class="item-container" *ngIf="selectedAddress?.building_street_No">
                      <p>{{ 'Building Number' | translate }}</p>
                      <p class="data">{{ selectedAddress?.building_street_No }}</p>
                    </div>

                    <div class="item-container" *ngIf="selectedAddress?.billing_street_Name">
                      <p>{{ 'Building Name' | translate }}</p>
                      <p class="data">{{ selectedAddress?.building_street_Name || '-' }}</p>
                    </div>

                    <div class="item-container" *ngIf="selectedAddress?.billing_address_type">
                      <p>{{ 'Address Type' | translate }}</p>
                      <p class="data">{{ selectedAddress?.billing_address_type || '-' }}</p>
                    </div>
                    <div class="item-container" *ngIf="selectedAddress?.billing_postcode">
                      <p>{{ 'Postcode' | translate }}</p>
                      <p class="data">{{ selectedAddress?.billing_postcode || '-' }}</p>
                    </div>

                    <div class="item-container"
                      *ngIf="orderData?.order?.deliveryAddress && !selectedAddress?.building_street_Name">
                      <p>{{ 'Address' | translate}}</p>
                      <p class="data">
                        {{ orderData?.order?.deliveryAddress || '-' }} </p>
                    </div>
                    <div class="item-container"
                      *ngIf="selectedAddress?.additional_info || orderData?.order?.deliveryNotes || orderData?.order?.order_comments">
                      <p>{{ 'Additional Info' | translate }}</p>
                      <p class="data">{{selectedAddress?.additional_info|| orderData?.order?.deliveryNotes ||
                        orderData?.order?.order_comments}}</p>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="AddressContainer" *ngIf="editAddress || customAddress">
      <!-- Add Addresses -->
      <div class="addressInfo">
        <div class="address-header">
          <h3>{{ 'Use Custom Address' | translate }}</h3>
        </div>
        <div class="customerWrapper">
          <form [formGroup]="addressForm">
            <div class="formWrapper">
              <ul>
                <div class="address-form" *ngIf="editAddress">
                  <p>{{ 'Address' | translate }}:</p>
                  <li>
                    <div class="row-container">
                      <mat-form-field appearance="outline">
                        <mat-label>{{ 'First Name' | translate }}</mat-label>
                        <input matInput formControlName="first_name" />
                      </mat-form-field>

                      <mat-form-field appearance="outline">
                        <mat-label>{{ 'Last Name' | translate }}</mat-label>
                        <input matInput formControlName="last_name" />
                      </mat-form-field>
                    </div>
                  </li>

                  <li>
                    <div class="row-container">
                      <mat-form-field appearance="outline" class="country-code">
                        <mat-label>{{ 'Select Code' | translate }}</mat-label>
                        <mat-select formControlName="country_code" (selectionChange)="updateCountry($event.value)"
                          [(value)]="addressForm.value.country_code">
                          <mat-option *ngFor="let code of countryDialCodes"
                            [value]="code.dial_code || addressForm.controls['country_code'].value"> {{ code.emoji }} {{
                            code.code }} ({{ code.dial_code }}) </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field appearance="outline">
                        <mat-label>{{ 'Phone number' | translate }}</mat-label>
                        <input matInput formControlName="billing_phone" type="tel"
                          [class.invalid]="!addressForm.controls.billing_phone.valid && addressForm.controls.billing_phone.touched"
                          (input)="updatePhoneNumber(addressForm.controls.country_code.value, $event)"
                          [value]="addressForm.controls['phone_number'].value" />
                      </mat-form-field>
                    </div>
                  </li>

                  <li>
                    <div class="row-container">
                      <ng-container>
                        <mat-form-field appearance="outline">
                          <mat-label>{{ 'Street No' | translate }}</mat-label>
                          <input matInput formControlName="billing_street_No" />
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                          <mat-label>{{ 'Street Name' | translate }}</mat-label>
                          <input matInput formControlName="billing_street_Name" />
                        </mat-form-field>
                      </ng-container>
                    </div>
                  </li>
                  <li>
                    <div class="row-container">
                      <mat-form-field appearance="outline">
                        <mat-label>{{ 'Select Country' | translate }}</mat-label>
                        <mat-select formControlName="billing_country" (selectionChange)="updateCountry($event.value)"
                          [(value)]="addressForm.value.billing_country">
                          <mat-option *ngFor="let country of shippingCountries" [value]="country.countryName">
                            {{ country.countryName }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>

                      <mat-form-field appearance="outline">
                        <mat-label>{{ 'Select State' | translate }}</mat-label>
                        <mat-select formControlName="billing_state" (selectionChange)="updateState($event.value)"
                          [(value)]="addressForm.value.billing_state"
                          [disabled]="!possibleGovernates || possibleGovernates.length === 0">
                          <mat-option *ngFor="let state of possibleGovernates" [value]="state.governorateName">
                            {{ state.governorateName }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </li>
                  <li>
                    <div class="row-container">
                      <mat-form-field appearance="outline">
                        <mat-label>{{ 'Post code' | translate }}</mat-label>
                        <input matInput formControlName="billing_postcode" />
                      </mat-form-field>

                      <mat-form-field appearance="outline">
                        <mat-label>{{ 'Address Type' | translate }}</mat-label>
                        <mat-select formControlName="billing_address_type"
                          [(value)]="addressForm.value.billing_address_type">
                          <mat-option *ngFor="let type of addressTypes" [value]="type">
                            {{ type }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </li>
                </div>
                <div class="customerDetails" *ngIf="!editAddress && customAddress">

                  <div class="row-container">
                    <div class="item-container">
                      <p>{{ 'Address' }}</p>
                      <p class="data">{{ addressForm.controls.billing_street_No.value }},{{
                        addressForm.controls.billing_street_Name.value }}</p>
                    </div>
                  </div>

                  <div class="item-container">
                    <p>{{ 'Country' | translate }}</p>
                    <p class="data">{{ addressForm.controls.billing_country.value }}</p>
                  </div>
                  <div class="item-container" *ngIf="addressForm.controls.billing_state.value">
                    <p>{{ 'State' | translate }}</p>
                    <p class="data">{{ addressForm.controls.billing_state.value }}</p>
                  </div>
                  <div class="item-container" *ngIf="addressForm.controls.country_code.value">
                    <p>{{ 'Country Code' | translate }}</p>
                    <p class="data">{{ addressForm.controls.country_code.value }}</p>
                  </div>
                  <div class="item-container" *ngIf="addressForm.controls.phone_number.value">
                    <p>{{ 'Phone Number' | translate }}</p>
                    <p class="data">{{ addressForm.controls.phone_number.value }}</p>
                  </div>

                  <div class="item-container">
                    <p>{{ 'Address Type' | translate }}</p>
                    <p class="data">{{ addressForm.controls.billing_address_type.value }}</p>
                  </div>
                </div>
              </ul>
              <ul>
                <div class="address-form" *ngIf="editAddress">
                  <p>{{ 'Notes' | translate }}:</p>
                  <li>
                    <mat-form-field appearance="outline" class="order-notes-textarea">
                      <mat-label>{{ 'Order Notes' | translate }}</mat-label>
                      <textarea matInput max-length="500" formControlName="order_notes" class="order-notes"
                        rows="12">{{ addressForm.value.order_notes }}</textarea>
                    </mat-form-field>
                  </li>
                </div>

                <div class="customerDetails" *ngIf="!editAddress && customAddress">
                  <div class="row-container">
                    <div class="item-container" *ngIf="addressForm.controls.order_notes.value">
                      <p>{{ 'Order Notes' | translate }}</p>
                      <p>{{ addressForm.controls.order_notes.value }}</p>
                    </div>
                  </div>
                </div>
              </ul>
            </div>
          </form>
          <div class="address-btn">
            <button class="stacksBtn blue" *ngIf="editAddress && !customAddress" (click)="addCustomAddress()">
              {{ 'Save Address' | translate }}
            </button>
            <button class="stacksBtn blue" *ngIf="editAddress && customAddress" (click)="updateAddressData()">
              {{ 'Save Address' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
